import moment from "moment-timezone";

import burmese from "moment/locale/my";
import burmeseZawgyi from "./myZawgyi";
import khmer from "moment/locale/km";
import english from "moment/locale/en-gb";
import thai from "moment/locale/th";
import nepali from "moment/locale/ne";
import vietnamese from "moment/locale/vi";
import malay from "moment/locale/ms";
import bengali from "moment/locale/bn";
import japanese from "moment/locale/ja";

export const updateMomentLocale = (lang) => {
  // Developer mode
  if (process.env.REACT_APP_DISABLE_TRANSLATIIONS === "true") {
    moment.tz.setDefault("Asia/Bangkok");
    moment.updateLocale("en", english);
    moment.locale("en");
    document.body.style.fontFamily = "inherit";
    return;
  }

  document.body.style.fontFamily = "inherit";

  switch (lang) {
    case "mm-u":
      moment.tz.setDefault("Asia/Yangon");
      moment.updateLocale("my", burmese);
      moment.locale("my");
      break;

    case "mm-z":
      moment.tz.setDefault("Asia/Yangon");
      moment.updateLocale("my-z", burmeseZawgyi);
      moment.locale("my-z");
      break;

    case "kh":
      moment.tz.setDefault("Asia/Phnom_Penh");
      moment.updateLocale("km", khmer);
      moment.locale("km");
      break;

    case "th":
      moment.tz.setDefault("Asia/Bangkok");
      moment.updateLocale("th", thai);
      moment.locale("th");
      document.body.style.fontFamily = "Sarabun";
      break;

    case "ne":
      moment.tz.setDefault("Asia/Kathmandu");
      moment.updateLocale("ne", nepali);
      moment.locale("ne");
      break;

    case "vi":
      moment.tz.setDefault("Asia/Ho_Chi_Minh");
      moment.updateLocale("vi", vietnamese);
      moment.locale("vi");
      break;

    case "ms":
      moment.tz.setDefault("Asia/Kuala_Lumpur");
      moment.updateLocale("ms", malay);
      moment.locale("ms");
      break;

    case "bn":
      moment.tz.setDefault("Asia/Dhaka");
      moment.updateLocale("bn", bengali);
      moment.locale("bn");
      break;

    case "ja":
      moment.tz.setDefault("Asia/Tokyo");
      moment.updateLocale("ja", japanese);
      moment.locale("ja");
      break;

    default:
      moment.tz.setDefault("Asia/Bangkok");
      moment.updateLocale("en", english);
      moment.locale("en");
  }
};
